
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form9DataInfoType } from '@/types/Information/Form9';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form9Layout extends Vue {

    @Prop({required:true})
    result!: form9DataInfoType;
}

